class RhythmButton extends HTMLElement {
  #type = undefined;
  #value = undefined;

  constructor() {
    super();
    this.#type = this.getAttribute("data-type");
    this.#value = this.textContent;
    this.setAttribute("data-value", this.#value);
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      this.deselectOthers();
      this.updateContainer();
      this.classList.add("selected");
    });

    this.addEventListener("click", async () => {
      this.dataset.received = null;
      console.log("this", this.dataset.type, this.dataset.value);

      const event = new CustomEvent("submit-data", {
        bubbles: true,
        composed: true,
        detail: {
          endpoint: "/entries/append-rhythm-tag",
          method: "POST",
          payload: {
            entry: {
              rhythm: { [this.dataset.type]: Number(this.dataset.value) },
            },
          },
        },
      });

      this.dispatchEvent(event);

      if (event.detail.response) {
        this.dataset.received = "true";
      }
    });
  }

  deselectOthers() {
    const others = document.querySelectorAll(`rhythm-button[data-type="${this.#type}"].selected`);

    others?.forEach((button) => {
      button.classList.remove("selected");
    });
  }

  updateContainer() {
    this.closest("rhythm-container")?.setAttribute("data-value", this.#value);
  }
}

customElements.define("rhythm-button", RhythmButton);
